export default {"src":"/_next/static/media/footer-submit-arrow.2f167a69.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};